module.exports = __webpack_public_path__ + "static/media/CLA_CSV_8.c20c4e59.svg";